import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const StudentHelp = () => {
  const routes = all_routes;
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  // Mock FAQ data
  const faqData = [
    {
      id: 1,
      category: "academic",
      question: "How do I submit my homework?",
      answer:
        "Go to 'Tasks' section, find your assignment, and click 'Submit'. Upload your file and click confirm.",
    },
    {
      id: 2,
      category: "academic",
      question: "Where can I check my grades?",
      answer:
        "Navigate to 'My Classes' > 'Grades Summary' or go directly to the Grades page from the dashboard.",
    },
    {
      id: 3,
      category: "attendance",
      question: "How is attendance calculated?",
      answer:
        "Attendance is calculated as (Present Days / Total School Days) × 100%. You need 75% minimum attendance.",
    },
    {
      id: 4,
      category: "technical",
      question: "I forgot my password. How do I reset it?",
      answer:
        "Click 'Forgot Password' on the login screen and follow the instructions sent to your email.",
    },
    {
      id: 5,
      category: "technical",
      question: "The app is running slowly. What should I do?",
      answer:
        "Try refreshing the page, clearing your browser cache, or contact tech support if the issue persists.",
    },
    {
      id: 6,
      category: "general",
      question: "How do I contact my teachers?",
      answer:
        "Use the 'Messages' section to send messages directly to your teachers or use the contact information provided.",
    },
    {
      id: 7,
      category: "general",
      question: "Where can I see school events?",
      answer:
        "Check the 'Events Calendar' section for upcoming school activities, competitions, and important dates.",
    },
    {
      id: 8,
      category: "academic",
      question: "Can I request documents online?",
      answer:
        "Yes, go to 'Menu' > 'Document Requests' to request transcripts, certificates, and other official documents.",
    },
  ];

  const categories = [
    { value: "all", label: "All Categories", icon: "ti-help" },
    { value: "academic", label: "Academic", icon: "ti-book" },
    { value: "attendance", label: "Attendance", icon: "ti-calendar-check" },
    { value: "technical", label: "Technical", icon: "ti-settings" },
    { value: "general", label: "General", icon: "ti-info-circle" },
  ];

  const filteredFAQs = faqData.filter((faq) => {
    const matchesCategory =
      selectedCategory === "all" || faq.category === selectedCategory;
    const matchesSearch =
      searchTerm === "" ||
      faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const contactInfo = [
    {
      title: "Academic Support",
      icon: "ti-book",
      contact: "academic@school.edu",
      phone: "+1 (555) 123-4567",
      hours: "Mon-Fri: 8:00 AM - 4:00 PM",
    },
    {
      title: "Technical Support",
      icon: "ti-headphones",
      contact: "techsupport@school.edu",
      phone: "+1 (555) 123-4568",
      hours: "Mon-Fri: 7:00 AM - 6:00 PM",
    },
    {
      title: "Student Services",
      icon: "ti-users",
      contact: "studentservices@school.edu",
      phone: "+1 (555) 123-4569",
      hours: "Mon-Fri: 8:00 AM - 5:00 PM",
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Help & FAQ</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card bg-success">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Help & FAQ</h3>
                      <p>Find answers and get support when you need it</p>
                    </div>
                    <div className="avatar avatar-lg">
                      <i className="ti ti-help text-white fs-1"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Search and Filter */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-8">
                      <div className="input-group">
                        <span className="input-group-text">
                          <i className="ti ti-search"></i>
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search for help topics..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <select
                        className="form-select"
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                      >
                        {categories.map((cat) => (
                          <option key={cat.value} value={cat.value}>
                            {cat.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Categories */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Browse by Category</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    {categories
                      .filter((cat) => cat.value !== "all")
                      .map((category) => (
                        <div
                          key={category.value}
                          className="col-md-6 col-lg-3 mb-3"
                        >
                          <button
                            className={`btn w-100 p-3 ${
                              selectedCategory === category.value
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => setSelectedCategory(category.value)}
                          >
                            <i
                              className={`ti ${category.icon} fs-2 d-block mb-2`}
                            ></i>
                            <span>{category.label}</span>
                            <small className="d-block text-muted">
                              {
                                faqData.filter(
                                  (faq) => faq.category === category.value
                                ).length
                              }{" "}
                              topics
                            </small>
                          </button>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">
                    Frequently Asked Questions
                    <span className="badge bg-primary ms-2">
                      {filteredFAQs.length}
                    </span>
                  </h5>
                </div>
                <div className="card-body">
                  {filteredFAQs.length > 0 ? (
                    <div className="accordion" id="faqAccordion">
                      {filteredFAQs.map((faq, index) => (
                        <div key={faq.id} className="accordion-item mb-2">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#faq${faq.id}`}
                            >
                              <i className="ti ti-help-circle me-2"></i>
                              {faq.question}
                            </button>
                          </h2>
                          <div
                            id={`faq${faq.id}`}
                            className="accordion-collapse collapse"
                            data-bs-parent="#faqAccordion"
                          >
                            <div className="accordion-body">{faq.answer}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <div className="avatar avatar-lg bg-light mb-3">
                        <i className="ti ti-search-off fs-2 text-muted"></i>
                      </div>
                      <h5>No results found</h5>
                      <p className="text-muted">
                        Try adjusting your search terms or category filter.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Contact Support */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Contact Support</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    {contactInfo.map((contact, index) => (
                      <div key={index} className="col-md-4 mb-3">
                        <div className="p-3 bg-light rounded text-center">
                          <div className="avatar avatar-lg bg-primary-transparent mb-3">
                            <i
                              className={`ti ${contact.icon} fs-2 text-primary`}
                            ></i>
                          </div>
                          <h6>{contact.title}</h6>
                          <p className="mb-1">
                            <i className="ti ti-mail me-1"></i>
                            {contact.contact}
                          </p>
                          <p className="mb-1">
                            <i className="ti ti-phone me-1"></i>
                            {contact.phone}
                          </p>
                          <small className="text-muted">{contact.hours}</small>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="text-center mt-4">
                    <button className="btn btn-primary me-2">
                      <i className="ti ti-message me-2"></i>
                      Send Support Message
                    </button>
                    <button className="btn btn-outline-primary">
                      <i className="ti ti-phone me-2"></i>
                      Request Call Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentHelp;
